import { ActionIcon } from '@mantine/core'
import { User, UserService, useUserRole } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { ConfirmationModal } from '@ospace/shared'
import { IconPasswordUser } from '@tabler/icons-react'
import React from 'react'
import { useMutation } from 'react-query'

import { useUser } from '../hooks/useUser'

export const ForgetPasswordButton = ({ user }: { user: User }) => {
  const mutation = useMutation((values: any) => {
    return UserService.forgotPassword({
      email: values.email,
    })
  })

  const role = useUserRole()
  const { data: currentUser } = useUser()

  const actionHandler = async () => {
    await mutation.mutateAsync(user)
  }
  // if (role !== userTypes.Admin) return null
  return (
    <div className='d-flex'>
      <ConfirmationModal
        alertMessage={
          <div>
            Are you sure you want to forget password for {user.firstName} {user.lastName}?
          </div>
        }
        action={actionHandler}
        renderButton={(rp) => (
          <ActionIcon
            {...rp}
            disabled={user.id === currentUser?.id}
            color={user.deletedAt ? 'blue' : 'red'}
            loading={mutation.isLoading && mutation.variables?.identityId === user.identityId}
          >
            <IconPasswordUser />
          </ActionIcon>
        )}
        isLoading={mutation.isLoading && mutation.variables?.identityId === user.identityId}
      />
    </div>
  )
}
